import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class StatusDtcHistory implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES:
        ' 62 01 02 0A 00 9A 00 14 16 02 0E 00 12 26 0A 01 00 9A 00 14 16 02 0E 00 12 0C 0D 01 00 9A 00 14 16 02 0E 00 12 09 21 01 00 9A 00 14 16 02 0E 00 11 2B 15 01 00 9A 00 14 16 02 07 00 0C 27 06 01 00 9A 00 14 16 02 07 00 0C 25 2A 01 00 3C 00 14 16 02 06 06 16 01 1B 01 00 3C 00 14 16 02 05 05 16 01 1B 01 00 3C 00 14 16 02 04 04 16 01 1C 01 00 3C 00 14 16 02 03 03 16 01 00 01 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0002_HMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.StatusDtcHistory,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'StatusDtcHistory',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'ENTRIES',
              path: 'PA_DataRecor/PA_Entri',
              unit: '',
              translationid: 'TI_Entries',
              dopname: '2 Byte Identical uint16',
              name: 'PA_Entri',
              value: '10',
            },
            {
              semantic: 'FAULTREAD',
              path: 'PA_DataRecor/PA_DTC',
              translationid: 'TI_DTC',
              dopname: 'EOPF Structure DTC Status',
              name: 'PA_DTC',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'NoBurnerOperationDueToInsufficientWaterFlow',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '14',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '18',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '38',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '10',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'NoBurnerOperationDueToInsufficientWaterFlow',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '14',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '18',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '12',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '13',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'NoBurnerOperationDueToInsufficientWaterFlow',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '14',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '18',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '9',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '33',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'NoBurnerOperationDueToInsufficientWaterFlow',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '14',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '17',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '43',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '21',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'NoBurnerOperationDueToInsufficientWaterFlow',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '7',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '12',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '39',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '6',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'NoBurnerOperationDueToInsufficientWaterFlow',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '7',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Monday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '12',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '37',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '42',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'SummerMode',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '6',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Sunday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '22',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '1',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '27',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'SummerMode',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '5',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Saturday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '22',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '1',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '27',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'SummerMode',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '4',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Friday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '22',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '1',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '28',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu',
                  translationid: '',
                  dopname: '12 Byte Structure DTC Status',
                  name: 'STR_12ByteStrucDTCStatu',
                  structure: [
                    {
                      semantic: 'FAULTREAD',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                      unit: '',
                      translationid: 'TI_DtcStatus',
                      dopname: '2 Byte TextTable DTCStatus',
                      name: 'PA_DTC',
                      value: 'SummerMode',
                    },
                    {
                      semantic: 'DATETIME',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                      translationid: 'TI_Time',
                      dopname: '8 Byte Structure DateTime',
                      name: 'PA_DtcTime',
                      structure: [
                        {
                          semantic: 'DATE',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                          translationid: 'TI_Date',
                          dopname: '4 Byte Structure Date',
                          name: 'PA_Date',
                          structure: [
                            {
                              semantic: 'CENTURY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                              unit: '',
                              translationid: 'TI_Century',
                              dopname: '1 Byte Identical uint8 Century',
                              name: 'PA_Centu',
                              value: '20',
                            },
                            {
                              semantic: 'YEAR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                              unit: 'yr',
                              translationid: 'TI_Year',
                              dopname: '1 Byte Identical uint8 Year',
                              name: 'PA_Year',
                              value: '22',
                            },
                            {
                              semantic: 'MONTH',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                              unit: 'm',
                              translationid: 'TI_Month',
                              dopname: '1 Byte Identical uint8 Month',
                              name: 'PA_Month',
                              value: '2',
                            },
                            {
                              semantic: 'DAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                              unit: 'd',
                              translationid: 'TI_Day',
                              dopname: '1 Byte Identical uint8 Day',
                              name: 'PA_Day',
                              value: '3',
                            },
                          ],
                        },
                        {
                          semantic: 'TIME',
                          path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                          translationid: 'TI_Time',
                          dopname: '4 Byte Structure Time',
                          name: 'PA_Time',
                          structure: [
                            {
                              semantic: 'WEEKDAY',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                              unit: '',
                              translationid: 'TI_Weekday',
                              dopname: '1 Byte TextTable WeekDay',
                              name: 'PA_Weekd',
                              value: 'Thursday',
                            },
                            {
                              semantic: 'HOUR',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                              unit: 'h',
                              translationid: 'TI_Hour',
                              dopname: '1 Byte Identical uint8 Hour',
                              name: 'PA_Hour',
                              value: '22',
                            },
                            {
                              semantic: 'MINUTE',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                              unit: 'min',
                              translationid: 'TI_Minute',
                              dopname: '1 Byte Identical uint8 Minute',
                              name: 'PA_Minut',
                              value: '1',
                            },
                            {
                              semantic: 'SECOND',
                              path:
                                'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                              unit: 's',
                              translationid: 'TI_Second',
                              dopname: '1 Byte Identical uint8 Second',
                              name: 'PA_Secon',
                              value: '0',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'OwnBus',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 02',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.StatusDtcHistory,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '258',
          value: 'StatusDtcHistory',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '0',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'False',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.StatusDtcHistory,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '258',
              value: 'StatusDtcHistory',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'ENTRIES',
                  longname: 'Entries',
                  byteposition: '0',
                  dopname: '2 Byte Identical uint16',
                  precision: '',
                  byteLength: '16',
                  type: 'eA_UINT32',
                  shortname: 'PA_Entri',
                  constraints: '[0:65535]',
                  path: 'PA_Struc/PA_Entri',
                  unit: '',
                  translationid: 'TI_Entries',
                  bitposition: '0',
                  name: 'PA_Entri',
                  value: '0',
                },
                {
                  semantic: 'FAULTREAD',
                  longname: 'DTC',
                  byteposition: '2',
                  dopname: 'EOPF Structure DTC Status',
                  precision: '',
                  byteLength: '-1',
                  type: 'eEND_OF_PDU',
                  shortname: 'PA_DTC',
                  constraints: '[1:32767]',
                  structure: [
                    {
                      semantic: '',
                      longname: '12 Byte Structure DTC Status',
                      byteposition: '-1',
                      dopname: '12 Byte Structure DTC Status',
                      precision: '',
                      byteLength: '-1',
                      type: 'eSTRUCTURE',
                      shortname: 'STR_12ByteStrucDTCStatu',
                      constraints: '',
                      structure: [
                        {
                          semantic: 'FAULTREAD',
                          longname: 'DTC',
                          byteposition: '0',
                          dopname: '2 Byte TextTable DTCStatus',
                          precision: '',
                          byteLength: '16',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_DTC',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_S_0',
                              interval: '0',
                              texttableentry: 'NoStatus',
                            },
                            {
                              TI_texttableentry: 'TI_S_1',
                              interval: '1',
                              texttableentry: 'PowerOn',
                            },
                            {
                              TI_texttableentry: 'TI_S_2',
                              interval: '2',
                              texttableentry: 'InitialisationOperationSystem',
                            },
                            {
                              TI_texttableentry: 'TI_S_3',
                              interval: '3',
                              texttableentry: 'PowerOnSelftest',
                            },
                            {
                              TI_texttableentry: 'TI_S_4',
                              interval: '4',
                              texttableentry: 'AktorSensorSelftest',
                            },
                            {
                              TI_texttableentry: 'TI_S_5',
                              interval: '5',
                              texttableentry: 'HvacTopologieScan',
                            },
                            {
                              TI_texttableentry: 'TI_S_6',
                              interval: '6',
                              texttableentry: 'Standby',
                            },
                            {
                              TI_texttableentry: 'TI_S_7',
                              interval: '7',
                              texttableentry: 'PrerunCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_S_8',
                              interval: '8',
                              texttableentry: 'DomesticHotWaterPumpIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_9',
                              interval: '9',
                              texttableentry: 'FanInPrerunModeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_10',
                              interval: '10',
                              texttableentry: 'FanInPrerunModeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_11',
                              interval: '11',
                              texttableentry: 'FanInPrerunModeDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_12',
                              interval: '12',
                              texttableentry: 'PreIgnitionCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_13',
                              interval: '13',
                              texttableentry: 'PreIgnitionDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_14',
                              interval: '14',
                              texttableentry: 'PreIgnitionDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_15',
                              interval: '15',
                              texttableentry: 'IgnitionCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_16',
                              interval: '16',
                              texttableentry: 'IgnitionDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_17',
                              interval: '17',
                              texttableentry: 'IgnitionDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_18',
                              interval: '18',
                              texttableentry: 'FlameDetectionCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_19',
                              interval: '19',
                              texttableentry: 'FlameDetectionDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_20',
                              interval: '20',
                              texttableentry: 'FlameDetectionDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_21',
                              interval: '21',
                              texttableentry: 'FlameStabilisationCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_22',
                              interval: '22',
                              texttableentry: 'FlameStabilisationDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_23',
                              interval: '23',
                              texttableentry: 'FlameStabilisationDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_24',
                              interval: '24',
                              texttableentry: 'ModulationBlockingTimeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_25',
                              interval: '25',
                              texttableentry: 'ModulationBlockingTimeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_26',
                              interval: '26',
                              texttableentry: 'ModulationBlockingTimeDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_27',
                              interval: '27',
                              texttableentry: 'ActiveHeaterGeneratorCentralHeatingReducedMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_28',
                              interval: '28',
                              texttableentry: 'ActiveHeaterGeneratorCentralHeatingEcoMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_29',
                              interval: '29',
                              texttableentry: 'ActiveHeaterGeneratorCentralHeatingComfortMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_30',
                              interval: '30',
                              texttableentry: 'ActiveHeaterGeneratorCentralHeatingPartyMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_31',
                              interval: '31',
                              texttableentry: 'ActiveHeaterGeneratorDomesticHotWaterReducedMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_32',
                              interval: '32',
                              texttableentry: 'ActiveHeaterGeneratorDomesticHotWaterEcoMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_33',
                              interval: '33',
                              texttableentry: 'ActiveHeaterGeneratorDomesticHotWaterComfortMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_34',
                              interval: '34',
                              texttableentry: 'ActiveHeaterGeneratorDomesticHotWaterPartyMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_35',
                              interval: '35',
                              texttableentry: 'ActiveHeaterGeneratorDomesticHotWaterTappingEcoMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_36',
                              interval: '36',
                              texttableentry:
                                'ActiveHeaterGeneratorDomesticHotWaterTappingComfortMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_37',
                              interval: '37',
                              texttableentry: 'PassiveNaturalCoolingMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_38',
                              interval: '38',
                              texttableentry: 'ActiveCoolingMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_39',
                              interval: '39',
                              texttableentry: 'FanInPostrunMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_40',
                              interval: '40',
                              texttableentry: 'ProstrunCentralHeatingPump',
                            },
                            {
                              TI_texttableentry: 'TI_S_41',
                              interval: '41',
                              texttableentry: 'PostrunDomesticHotWaterPump',
                            },
                            {
                              TI_texttableentry: 'TI_S_42',
                              interval: '42',
                              texttableentry: 'CentralHeatingPumpCirculationMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_43',
                              interval: '43',
                              texttableentry: 'MinimumPowerTestModeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_44',
                              interval: '44',
                              texttableentry: 'PartloadPowerTestModeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_45',
                              interval: '45',
                              texttableentry: 'MaximumPowerTestModeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_46',
                              interval: '46',
                              texttableentry: 'MinimumPowerTestModeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_47',
                              interval: '47',
                              texttableentry: 'PartloadPowerTestModeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_48',
                              interval: '48',
                              texttableentry: 'MaximumPowerTestModeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_49',
                              interval: '49',
                              texttableentry: 'MinimumPowerTestModeDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_50',
                              interval: '50',
                              texttableentry: 'PartloadPowerTestModeDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_51',
                              interval: '51',
                              texttableentry: 'MaximumPowerTestModeDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_52',
                              interval: '52',
                              texttableentry: 'SafetyTemperatureLimiterTestModeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_53',
                              interval: '53',
                              texttableentry: 'SafetyTemperatureLimiterTestModeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_54',
                              interval: '54',
                              texttableentry: 'SafetyExhaustTemperatureLimiterTestMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_55',
                              interval: '55',
                              texttableentry: 'ChimneySweeperTestModeCentralHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_56',
                              interval: '56',
                              texttableentry: 'ChimneySweeperTestModeDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_57',
                              interval: '57',
                              texttableentry: 'ChimneySweeperTestModeDomesticHotWaterTapping',
                            },
                            {
                              TI_texttableentry: 'TI_S_58',
                              interval: '58',
                              texttableentry: 'FlueGasSensorDetectionStart',
                            },
                            {
                              TI_texttableentry: 'TI_S_59',
                              interval: '59',
                              texttableentry: 'FlueGasSensorDetectionActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_60',
                              interval: '60',
                              texttableentry: 'SummerMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_61',
                              interval: '61',
                              texttableentry: 'FuelCellRegenerationActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_62',
                              interval: '62',
                              texttableentry: 'FuelCellStandby',
                            },
                            {
                              TI_texttableentry: 'TI_S_63',
                              interval: '63',
                              texttableentry: 'FuelCellHeatingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_64',
                              interval: '64',
                              texttableentry: 'FuelCellDomesticHotWaterActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_65',
                              interval: '65',
                              texttableentry: 'IdleStateCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_66',
                              interval: '66',
                              texttableentry: 'FanPreRunRotationCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_67',
                              interval: '67',
                              texttableentry: 'FanPostRunRotationCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_68',
                              interval: '68',
                              texttableentry: 'BurnerInRaisedMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_69',
                              interval: '69',
                              texttableentry: 'ValveCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_70',
                              interval: '70',
                              texttableentry: 'RelaisCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_71',
                              interval: '71',
                              texttableentry: 'StartUpSignalCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_72',
                              interval: '72',
                              texttableentry: 'FanForcedVentilationRotationCheck',
                            },
                            {
                              TI_texttableentry: 'TI_S_73',
                              interval: '73',
                              texttableentry: 'FanInForcedVentilationMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_74',
                              interval: '74',
                              texttableentry: 'SolarHeatingSuppression',
                            },
                            {
                              TI_texttableentry: 'TI_S_75',
                              interval: '75',
                              texttableentry: 'DomesticHotWaterCirculationPumpIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_76',
                              interval: '76',
                              texttableentry: 'CentralHeatingPumpIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_77',
                              interval: '77',
                              texttableentry: 'AirBackflowFlapCheckActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_78',
                              interval: '78',
                              texttableentry: 'BatteryPreCharging',
                            },
                            {
                              TI_texttableentry: 'TI_S_79',
                              interval: '79',
                              texttableentry: 'BatteryIdle',
                            },
                            {
                              TI_texttableentry: 'TI_S_80',
                              interval: '80',
                              texttableentry: 'BatteryCharging',
                            },
                            {
                              TI_texttableentry: 'TI_S_81',
                              interval: '81',
                              texttableentry: 'BatteryDischarging',
                            },
                            {
                              TI_texttableentry: 'TI_S_82',
                              interval: '82',
                              texttableentry: 'BatterySelftest',
                            },
                            {
                              TI_texttableentry: 'TI_S_83',
                              interval: '83',
                              texttableentry: 'FuelCellStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_84',
                              interval: '84',
                              texttableentry: 'FuelCellGeneration',
                            },
                            {
                              TI_texttableentry: 'TI_S_85',
                              interval: '85',
                              texttableentry: 'FuelCellStop',
                            },
                            {
                              TI_texttableentry: 'TI_S_86',
                              interval: '86',
                              texttableentry: 'FuelCellMaintenance',
                            },
                            {
                              TI_texttableentry: 'TI_S_87',
                              interval: '87',
                              texttableentry: 'FuelCellStopWithForcedCooling',
                            },
                            {
                              TI_texttableentry: 'TI_S_88',
                              interval: '88',
                              texttableentry: 'PrimarySolarPumpIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_89',
                              interval: '89',
                              texttableentry: 'SolarSystemInStagnation',
                            },
                            {
                              TI_texttableentry: 'TI_S_90',
                              interval: '90',
                              texttableentry: 'MinimumBurnerBlocking',
                            },
                            {
                              TI_texttableentry: 'TI_S_91',
                              interval: '91',
                              texttableentry: 'CalibrationRequest',
                            },
                            {
                              TI_texttableentry: 'TI_S_92',
                              interval: '92',
                              texttableentry: 'CalibrationIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_93',
                              interval: '93',
                              texttableentry: 'MountingMode',
                            },
                            {
                              TI_texttableentry: 'TI_S_94',
                              interval: '94',
                              texttableentry: 'MixerOneCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_95',
                              interval: '95',
                              texttableentry: 'MixerTwoCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_96',
                              interval: '96',
                              texttableentry: 'MixerThreeCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_97',
                              interval: '97',
                              texttableentry: 'MixerFourCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_98',
                              interval: '98',
                              texttableentry: 'MixerFiveCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_99',
                              interval: '99',
                              texttableentry: 'MixerSixCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_100',
                              interval: '100',
                              texttableentry: 'MixerSevenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_101',
                              interval: '101',
                              texttableentry: 'MixerEightCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_102',
                              interval: '102',
                              texttableentry: 'MixerNineCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_103',
                              interval: '103',
                              texttableentry: 'MixerTenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_104',
                              interval: '104',
                              texttableentry: 'MixerElevenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_105',
                              interval: '105',
                              texttableentry: 'MixerTwelveCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_106',
                              interval: '106',
                              texttableentry: 'MixerThirteenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_107',
                              interval: '107',
                              texttableentry: 'MixerFourteenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_108',
                              interval: '108',
                              texttableentry: 'MixerFifteenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_109',
                              interval: '109',
                              texttableentry: 'MixerSixteenCircuitExternalHookupNoDemandFromZones',
                            },
                            {
                              TI_texttableentry: 'TI_S_110',
                              interval: '110',
                              texttableentry: 'RefrigerationCircuitReadyForOperation',
                            },
                            {
                              TI_texttableentry: 'TI_S_111',
                              interval: '111',
                              texttableentry: 'AdditionalElectricHeaterIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_112',
                              interval: '112',
                              texttableentry: 'FourThreeWayValveInitializationPhase',
                            },
                            {
                              TI_texttableentry: 'TI_S_113',
                              interval: '113',
                              texttableentry:
                                'FourThreeWayValveFromRoomSpaceClimateToDomesticHotWater',
                            },
                            {
                              TI_texttableentry: 'TI_S_114',
                              interval: '114',
                              texttableentry:
                                'FourThreeWayValveFromDomesticHotWaterToRoomSpaceClimate',
                            },
                            {
                              TI_texttableentry: 'TI_S_115',
                              interval: '115',
                              texttableentry: 'FourThreeWayValveDomesticHotWaterPosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_116',
                              interval: '116',
                              texttableentry: 'FourThreeWayValveRoomSpaceClimateOnePosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_117',
                              interval: '117',
                              texttableentry: 'FourThreeWayValveRoomSpaceClimateTwoPosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_118',
                              interval: '118',
                              texttableentry: 'FourThreeWayValveInternalBufferPosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_119',
                              interval: '119',
                              texttableentry: 'DefrostingModeOutDoorUnitActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_120',
                              interval: '120',
                              texttableentry: 'NormalOperation',
                            },
                            {
                              TI_texttableentry: 'TI_S_121',
                              interval: '121',
                              texttableentry: 'SmartGridRecommendedOperation',
                            },
                            {
                              TI_texttableentry: 'TI_S_122',
                              interval: '122',
                              texttableentry: 'SmartGridForcedOperation',
                            },
                            {
                              TI_texttableentry: 'TI_S_123',
                              interval: '123',
                              texttableentry: 'HeatPumpOff',
                            },
                            {
                              TI_texttableentry: 'TI_S_124',
                              interval: '124',
                              texttableentry: 'HeatPumpPreRun',
                            },
                            {
                              TI_texttableentry: 'TI_S_125',
                              interval: '125',
                              texttableentry: 'HeatPumpHeatingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_126',
                              interval: '126',
                              texttableentry: 'HeatPumpCoolingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_127',
                              interval: '127',
                              texttableentry: 'HeatPumpPrepDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_S_128',
                              interval: '128',
                              texttableentry: 'HeatPumpDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_S_129',
                              interval: '129',
                              texttableentry: 'HeatPumpPostRun',
                            },
                            {
                              TI_texttableentry: 'TI_S_130',
                              interval: '130',
                              texttableentry: 'ElectricalHeaterOff',
                            },
                            {
                              TI_texttableentry: 'TI_S_131',
                              interval: '131',
                              texttableentry: 'ElectricalHeaterPhaseOneActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_132',
                              interval: '132',
                              texttableentry: 'ElectricalHeaterPhaseTwoActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_133',
                              interval: '133',
                              texttableentry: 'ElectricalHeaterPhaseThreeActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_134',
                              interval: '134',
                              texttableentry: 'FourThreeWayValveIdlePosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_135',
                              interval: '135',
                              texttableentry: 'FourThreeWayValveDefrostPosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_136',
                              interval: '136',
                              texttableentry: 'FourThreeWayValveRoomSpaceClimateOneTwoPosition',
                            },
                            {
                              TI_texttableentry: 'TI_S_137',
                              interval: '137',
                              texttableentry: 'ControlLoopHeatingStateStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_138',
                              interval: '138',
                              texttableentry: 'ControlLoopHeatingStateRun',
                            },
                            {
                              TI_texttableentry: 'TI_S_139',
                              interval: '139',
                              texttableentry: 'ControlLoopHeatingStateShutdown',
                            },
                            {
                              TI_texttableentry: 'TI_S_140',
                              interval: '140',
                              texttableentry: 'ControlLoopDhwStateStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_141',
                              interval: '141',
                              texttableentry: 'ControlLoopDhwStateRun',
                            },
                            {
                              TI_texttableentry: 'TI_S_142',
                              interval: '142',
                              texttableentry: 'ControlLoopDhwStateShutdown',
                            },
                            {
                              TI_texttableentry: 'TI_S_143',
                              interval: '143',
                              texttableentry: 'ControlLoopCoolingStateStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_144',
                              interval: '144',
                              texttableentry: 'ControlLoopCoolingStateRun',
                            },
                            {
                              TI_texttableentry: 'TI_S_145',
                              interval: '145',
                              texttableentry: 'ControlLoopCoolingStateShutdown',
                            },
                            {
                              TI_texttableentry: 'TI_S_146',
                              interval: '146',
                              texttableentry: 'ControlLoopDefrostStateStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_147',
                              interval: '147',
                              texttableentry: 'ControlLoopDefrostStatePrepareDefrostEnergy',
                            },
                            {
                              TI_texttableentry: 'TI_S_148',
                              interval: '148',
                              texttableentry: 'ControlLoopDefrostStateDefrosting',
                            },
                            {
                              TI_texttableentry: 'TI_S_149',
                              interval: '149',
                              texttableentry: 'ControlLoopDefrostStateShutdown',
                            },
                            {
                              TI_texttableentry: 'TI_S_150',
                              interval: '150',
                              texttableentry: 'ControlLoopBufferUnloadStateStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_151',
                              interval: '151',
                              texttableentry: 'ControlLoopBufferUnloadStateRun',
                            },
                            {
                              TI_texttableentry: 'TI_S_152',
                              interval: '152',
                              texttableentry: 'ControlLoopBufferUnloadStateShutdown',
                            },
                            {
                              TI_texttableentry: 'TI_S_153',
                              interval: '153',
                              texttableentry: 'AllControlLoopsIdle',
                            },
                            {
                              TI_texttableentry: 'TI_S_154',
                              interval: '154',
                              texttableentry: 'NoBurnerOperationDueToInsufficientWaterFlow',
                            },
                            {
                              TI_texttableentry: 'TI_S_155',
                              interval: '155',
                              texttableentry: 'HeatingRoomSetpointActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_156',
                              interval: '156',
                              texttableentry: 'ReducedHeatingRoomSetpointActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_157',
                              interval: '157',
                              texttableentry: 'CoolingSetpointActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_158',
                              interval: '158',
                              texttableentry: 'ReducedCoolingSetpointActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_159',
                              interval: '159',
                              texttableentry: 'HumidityRoomSetpointActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_160',
                              interval: '160',
                              texttableentry: 'DomesticHotWaterSetpointActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_161',
                              interval: '161',
                              texttableentry: 'FillingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_162',
                              interval: '162',
                              texttableentry: 'VentingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_163',
                              interval: '163',
                              texttableentry: 'ApplicationSoftwareSystemStateInactive',
                            },
                            {
                              TI_texttableentry: 'TI_S_164',
                              interval: '164',
                              texttableentry: 'ApplicationSoftwareSystemStateServiceStandby',
                            },
                            {
                              TI_texttableentry: 'TI_S_165',
                              interval: '165',
                              texttableentry: 'ApplicationSoftwareSystemStateControl',
                            },
                            {
                              TI_texttableentry: 'TI_S_166',
                              interval: '166',
                              texttableentry: 'ComfortEnsuringModeActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_167',
                              interval: '167',
                              texttableentry: 'ActuatorTestModeActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_168',
                              interval: '168',
                              texttableentry: 'VentilationBypassOpen',
                            },
                            {
                              TI_texttableentry: 'TI_S_169',
                              interval: '169',
                              texttableentry: 'ExternalSafetyEquipmentOneFailureSignalInput',
                            },
                            {
                              TI_texttableentry: 'TI_S_170',
                              interval: '170',
                              texttableentry: 'ExternalSafetyEquipmentTwoFailureSignalInput',
                            },
                            {
                              TI_texttableentry: 'TI_S_171',
                              interval: '171',
                              texttableentry: 'ExternalSafetyEquipmentThreeFailureSignalInput',
                            },
                            {
                              TI_texttableentry: 'TI_S_172',
                              interval: '172',
                              texttableentry: 'ServiceStateFilterExchangeActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_173',
                              interval: '173',
                              texttableentry: 'ServiceStateAirVolumeFlowBalancingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_174',
                              interval: '174',
                              texttableentry: 'Reuse',
                            },
                            {
                              TI_texttableentry: 'TI_S_175',
                              interval: '175',
                              texttableentry: 'ReuseOne',
                            },
                            {
                              TI_texttableentry: 'TI_S_176',
                              interval: '176',
                              texttableentry: 'RefrigerantCycleRequestForDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_S_177',
                              interval: '177',
                              texttableentry: 'ReuseTwo',
                            },
                            {
                              TI_texttableentry: 'TI_S_178',
                              interval: '178',
                              texttableentry: 'ReuseThree',
                            },
                            {
                              TI_texttableentry: 'TI_S_179',
                              interval: '179',
                              texttableentry: 'ReuseFour',
                            },
                            {
                              TI_texttableentry: 'TI_S_180',
                              interval: '180',
                              texttableentry: 'ReuseFive',
                            },
                            {
                              TI_texttableentry: 'TI_S_181',
                              interval: '181',
                              texttableentry: 'PassiveFrostProtectionMixerCircuitOne',
                            },
                            {
                              TI_texttableentry: 'TI_S_182',
                              interval: '182',
                              texttableentry: 'PassiveFrostProtectionMixerCircuitTwo',
                            },
                            {
                              TI_texttableentry: 'TI_S_183',
                              interval: '183',
                              texttableentry: 'PassiveFrostProtectionMixerCircuitThree',
                            },
                            {
                              TI_texttableentry: 'TI_S_184',
                              interval: '184',
                              texttableentry: 'PassiveFrostProtectionMixerCircuitFour',
                            },
                            {
                              TI_texttableentry: 'TI_S_185',
                              interval: '185',
                              texttableentry: 'PassiveFrostProtectionElectricalHeater',
                            },
                            {
                              TI_texttableentry: 'TI_S_186',
                              interval: '186',
                              texttableentry: 'PassiveFrostProtectionDomesticHotWaterCylinder',
                            },
                            {
                              TI_texttableentry: 'TI_S_187',
                              interval: '187',
                              texttableentry: 'PassiveFrostProtectionHeatEngine',
                            },
                            {
                              TI_texttableentry: 'TI_S_188',
                              interval: '188',
                              texttableentry: 'PassiveFrostProtectionHeatingCoolingBuffer',
                            },
                            {
                              TI_texttableentry: 'TI_S_189',
                              interval: '189',
                              texttableentry: 'PassiveFrostProtectionHeatingBuffer',
                            },
                            {
                              TI_texttableentry: 'TI_S_190',
                              interval: '190',
                              texttableentry: 'PassiveFrostProtectionCoolingBuffer',
                            },
                            {
                              TI_texttableentry: 'TI_S_191',
                              interval: '191',
                              texttableentry: 'ElectronicControlUnitSafeStateOverTheAirIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_192',
                              interval: '192',
                              texttableentry: 'ElectronicControlUnitSafeStateCommissioningIsActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_193',
                              interval: '193',
                              texttableentry: 'ExternalHeaterActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_194',
                              interval: '194',
                              texttableentry: 'ReuseSix',
                            },
                            {
                              TI_texttableentry: 'TI_S_195',
                              interval: '195',
                              texttableentry: 'SmartGridLock',
                            },
                            {
                              TI_texttableentry: 'TI_S_196',
                              interval: '196',
                              texttableentry: 'PowerSupplierLock',
                            },
                            {
                              TI_texttableentry: 'TI_S_197',
                              interval: '197',
                              texttableentry: 'ClimateCircuitOneHeatingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_198',
                              interval: '198',
                              texttableentry: 'ClimateCircuitOneCoolingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_199',
                              interval: '199',
                              texttableentry: 'ClimateCircuitTwoHeatingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_200',
                              interval: '200',
                              texttableentry: 'ClimateCircuitTwoCoolingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_201',
                              interval: '201',
                              texttableentry: 'ClimateCircuitThreeHeatingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_202',
                              interval: '202',
                              texttableentry: 'ClimateCircuitThreeCoolingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_203',
                              interval: '203',
                              texttableentry: 'ClimateCircuitFourHeatingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_204',
                              interval: '204',
                              texttableentry: 'ClimateCircuitFourCoolingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_205',
                              interval: '205',
                              texttableentry: 'BufferHeatingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_206',
                              interval: '206',
                              texttableentry: 'BufferCoolingDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_207',
                              interval: '207',
                              texttableentry: 'DomesticHotWaterDemand',
                            },
                            {
                              TI_texttableentry: 'TI_S_208',
                              interval: '208',
                              texttableentry: 'HeatPumpDomesticHotWaterLoadingActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_209',
                              interval: '209',
                              texttableentry: 'FillingAborted',
                            },
                            {
                              TI_texttableentry: 'TI_S_210',
                              interval: '210',
                              texttableentry: 'VentingAborted',
                            },
                            {
                              TI_texttableentry: 'TI_S_211',
                              interval: '211',
                              texttableentry: 'FillingFinished',
                            },
                            {
                              TI_texttableentry: 'TI_S_212',
                              interval: '212',
                              texttableentry: 'VentingFinished',
                            },
                            {
                              TI_texttableentry: 'TI_S_213',
                              interval: '213',
                              texttableentry: 'SystemCommissioningActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_214',
                              interval: '214',
                              texttableentry: 'SystemCommissioningAborted',
                            },
                            {
                              TI_texttableentry: 'TI_S_215',
                              interval: '215',
                              texttableentry: 'SystemCommissioningFinished',
                            },
                            {
                              TI_texttableentry: 'TI_S_216',
                              interval: '216',
                              texttableentry: 'FunctionTestModeActive',
                            },
                            {
                              TI_texttableentry: 'TI_S_217',
                              interval: '217',
                              texttableentry: 'ElectHeaterPhaseOneDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_218',
                              interval: '218',
                              texttableentry: 'ElectHeaterPhaseTwoDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_219',
                              interval: '219',
                              texttableentry: 'ElectHeaterPhaseThreeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_220',
                              interval: '220',
                              texttableentry: 'RefrigerantCycleAppStateOff',
                            },
                            {
                              TI_texttableentry: 'TI_S_221',
                              interval: '221',
                              texttableentry: 'RefrigerantCycleAppStateHeatingStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_222',
                              interval: '222',
                              texttableentry: 'RefrigerantCycleAppStateCoolingStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_223',
                              interval: '223',
                              texttableentry: 'RefrigerantCycleAppStateDefrostStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_224',
                              interval: '224',
                              texttableentry: 'RefrigerantCycleAppStateHeatingControl',
                            },
                            {
                              TI_texttableentry: 'TI_S_225',
                              interval: '225',
                              texttableentry: 'RefrigerantCycleAppStateCoolingControl',
                            },
                            {
                              TI_texttableentry: 'TI_S_226',
                              interval: '226',
                              texttableentry: 'RefrigerantCycleAppStateDefrostControl',
                            },
                            {
                              TI_texttableentry: 'TI_S_227',
                              interval: '227',
                              texttableentry: 'RefrigerantCycleAppStateNaturalDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_S_228',
                              interval: '228',
                              texttableentry: 'RefrigerantCycleAppStateStopping',
                            },
                            {
                              TI_texttableentry: 'TI_S_229',
                              interval: '229',
                              texttableentry: 'RefrigerantCycleAppStateTransitionHeatingToCooling',
                            },
                            {
                              TI_texttableentry: 'TI_S_230',
                              interval: '230',
                              texttableentry: 'RefrigerantCycleAppStateTransitionCoolingToHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_231',
                              interval: '231',
                              texttableentry: 'RefrigerantCycleAppStateTransitionDefrostToHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_232',
                              interval: '232',
                              texttableentry:
                                'RefrigerantCycleAppStateTransitionHeatingToNaturalDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_S_233',
                              interval: '233',
                              texttableentry:
                                'RefrigerantCycleAppStateTransitionNaturalDefrostToHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_234',
                              interval: '234',
                              texttableentry: 'RefrigerantCycleAppStatePumpDownStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_235',
                              interval: '235',
                              texttableentry: 'RefrigerantCycleAppStatePumpDownControl',
                            },
                            {
                              TI_texttableentry: 'TI_S_236',
                              interval: '236',
                              texttableentry: 'RefrigerantCycleAppStatePumpDownStopping',
                            },
                            {
                              TI_texttableentry: 'TI_S_237',
                              interval: '237',
                              texttableentry: 'RefrigerantCycleAppStateManual',
                            },
                            {
                              TI_texttableentry: 'TI_S_238',
                              interval: '238',
                              texttableentry: 'RefrigerantCycleAppStateAlarm',
                            },
                            {
                              TI_texttableentry: 'TI_S_239',
                              interval: '239',
                              texttableentry: 'RefrigerantCycleAppStateWaiting',
                            },
                            {
                              TI_texttableentry: 'TI_S_240',
                              interval: '240',
                              texttableentry: 'RefrigerantCycleAppStateStandby',
                            },
                            {
                              TI_texttableentry: 'TI_S_241',
                              interval: '241',
                              texttableentry: 'RefrigerantCycleAppStateGridOperatorLock',
                            },
                            {
                              TI_texttableentry: 'TI_S_242',
                              interval: '242',
                              texttableentry: 'RefrigerantCycleAppStatePreStart',
                            },
                            {
                              TI_texttableentry: 'TI_S_243',
                              interval: '243',
                              texttableentry: 'RefrigerantCycleAppStatePostStop',
                            },
                            {
                              TI_texttableentry: 'TI_S_244',
                              interval: '244',
                              texttableentry: 'RefrigerantCycleAppStateUnintialized',
                            },
                            {
                              TI_texttableentry: 'TI_S_245',
                              interval: '245',
                              texttableentry: 'CompressorManualModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_246',
                              interval: '246',
                              texttableentry: 'CompressorManualModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_247',
                              interval: '247',
                              texttableentry: 'CompressorMaxEngineRoomTemperatureReached',
                            },
                            {
                              TI_texttableentry: 'TI_S_248',
                              interval: '248',
                              texttableentry: 'CompressorMaxEngineRoomTemperatureQuit',
                            },
                            {
                              TI_texttableentry: 'TI_S_249',
                              interval: '249',
                              texttableentry: 'CompressorMaxPressureDiffZoneTwoReached',
                            },
                            {
                              TI_texttableentry: 'TI_S_250',
                              interval: '250',
                              texttableentry: 'CompressorMaxPressureDiffZoneTwoQuit',
                            },
                            {
                              TI_texttableentry: 'TI_S_251',
                              interval: '251',
                              texttableentry: 'CompressorMaxCondensingPressureZoneThreeReached',
                            },
                            {
                              TI_texttableentry: 'TI_S_252',
                              interval: '252',
                              texttableentry: 'CompressorMaxCondensingPressureZoneThreeQuit',
                            },
                            {
                              TI_texttableentry: 'TI_S_253',
                              interval: '253',
                              texttableentry: 'CompressorStartup',
                            },
                            {
                              TI_texttableentry: 'TI_S_254',
                              interval: '254',
                              texttableentry: 'CompressorStartupFinished',
                            },
                            {
                              TI_texttableentry: 'TI_S_255',
                              interval: '255',
                              texttableentry: 'CompressorMaxEvaporatingTemperatureZoneFiveReached',
                            },
                            {
                              TI_texttableentry: 'TI_S_256',
                              interval: '256',
                              texttableentry: 'CompressorMaxEvaporatingTemperatureZoneFiveQuit',
                            },
                            {
                              TI_texttableentry: 'TI_S_257',
                              interval: '257',
                              texttableentry: 'CompressorFixLimitedSetpointToActualSpeedReached',
                            },
                            {
                              TI_texttableentry: 'TI_S_258',
                              interval: '258',
                              texttableentry: 'CompressorFixLimitedSetpointToActualSpeedQuit',
                            },
                            {
                              TI_texttableentry: 'TI_S_259',
                              interval: '259',
                              texttableentry: 'CompressorMaxDischargeTemperatureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_260',
                              interval: '260',
                              texttableentry: 'CompressorMaxDischargeTemperatureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_261',
                              interval: '261',
                              texttableentry: 'CompressorMinEvaporatingPressureZoneEightReached',
                            },
                            {
                              TI_texttableentry: 'TI_S_262',
                              interval: '262',
                              texttableentry: 'CompressorMinEvaporatingPressureZoneEightQuit',
                            },
                            {
                              TI_texttableentry: 'TI_S_263',
                              interval: '263',
                              texttableentry: 'CompressorFlowTemperatureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_264',
                              interval: '264',
                              texttableentry: 'CompressorFlowTemperatureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_265',
                              interval: '265',
                              texttableentry:
                                'CompressorMaximumSpeedDueToCondensingPressureActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_266',
                              interval: '266',
                              texttableentry:
                                'CompressorMaximumSpeedDueToCondensingPressureDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_267',
                              interval: '267',
                              texttableentry: 'CompressorMaxLimitedSpeedActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_268',
                              interval: '268',
                              texttableentry: 'CompressorMaxLimitedSpeedDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_269',
                              interval: '269',
                              texttableentry: 'CompressorNoiseReductionModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_270',
                              interval: '270',
                              texttableentry: 'CompressorNoiseReductionModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_271',
                              interval: '271',
                              texttableentry: 'CompressorMinSpeedIncreaseHeatingActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_272',
                              interval: '272',
                              texttableentry: 'CompressorMinSpeedIncreaseHeatingDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_273',
                              interval: '273',
                              texttableentry: 'CompressorMinSpeedDueToCondensingPressureActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_274',
                              interval: '274',
                              texttableentry:
                                'CompressorMinSpeedDueToCondensingPressureDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_275',
                              interval: '275',
                              texttableentry: 'CompressorMinLimitedSpeedActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_276',
                              interval: '276',
                              texttableentry: 'CompressorMinLimitedSpeedDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_277',
                              interval: '277',
                              texttableentry: 'CompressorIdle',
                            },
                            {
                              TI_texttableentry: 'TI_S_278',
                              interval: '278',
                              texttableentry: 'CompressorInputCurrentSpeedDropProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_279',
                              interval: '279',
                              texttableentry:
                                'CompressorInputCurrentSpeedDropProtectionDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_280',
                              interval: '280',
                              texttableentry: 'CompressorCurrentSpeedDropProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_281',
                              interval: '281',
                              texttableentry: 'CompressorCurrentSpeedDropProtectionDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_282',
                              interval: '282',
                              texttableentry:
                                'CompressorInternalPowerModulTemperatureSpeedDropProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_283',
                              interval: '283',
                              texttableentry:
                                'CompressorInternalPowerModulTemperatureSpeedDropProtectionDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_284',
                              interval: '284',
                              texttableentry:
                                'CompressorPowerFactorCorrectionTemperatureSpeedDropProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_285',
                              interval: '285',
                              texttableentry:
                                'CompressorPowerFactorCorrectionTemperatureSpeedDropProtectionDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_286',
                              interval: '286',
                              texttableentry: 'CompressorFieldWeakingProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_287',
                              interval: '287',
                              texttableentry: 'CompressorFieldWeakingProtectionDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_288',
                              interval: '288',
                              texttableentry: 'CompressorEngineRoomControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_289',
                              interval: '289',
                              texttableentry: 'CompressorEngineRoomControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_290',
                              interval: '290',
                              texttableentry: 'CompressorInverterParameterReset',
                            },
                            {
                              TI_texttableentry: 'TI_S_291',
                              interval: '291',
                              texttableentry: 'CompressorInverterDriveFaultActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_292',
                              interval: '292',
                              texttableentry: 'CompressorInverterDriveFaultDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_293',
                              interval: '293',
                              texttableentry: 'CompressorInverterReStartupActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_294',
                              interval: '294',
                              texttableentry: 'CompressorInverterReStartupDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_295',
                              interval: '295',
                              texttableentry: 'CompressorInverterSpeedStableActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_296',
                              interval: '296',
                              texttableentry: 'CompressorInverterSpeedStableDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_297',
                              interval: '297',
                              texttableentry: 'CompressorInverterSpeedLimitProtectionActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_298',
                              interval: '298',
                              texttableentry: 'CompressorInverterSpeedLimitProtectionDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_299',
                              interval: '299',
                              texttableentry: 'CompressorInverterParameterReadingStart',
                            },
                            {
                              TI_texttableentry: 'TI_S_300',
                              interval: '300',
                              texttableentry: 'CompressorInverterParameterReadingFinished',
                            },
                            {
                              TI_texttableentry: 'TI_S_301',
                              interval: '301',
                              texttableentry: 'ExpansionValveOneIdle',
                            },
                            {
                              TI_texttableentry: 'TI_S_302',
                              interval: '302',
                              texttableentry: 'ExpansionValveOneCalibrationActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_303',
                              interval: '303',
                              texttableentry: 'ExpansionValveOneCalibrationDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_304',
                              interval: '304',
                              texttableentry: 'ExpansionValveOnePressureEqualizationActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_305',
                              interval: '305',
                              texttableentry: 'ExpansionValveOnePressureEqualizationDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_306',
                              interval: '306',
                              texttableentry: 'ExpansionValveOneStartupActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_307',
                              interval: '307',
                              texttableentry: 'ExpansionValveOneStartupDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_308',
                              interval: '308',
                              texttableentry: 'ExpansionValveOneOpenLoopControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_309',
                              interval: '309',
                              texttableentry: 'ExpansionValveOneOpenLoopControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_310',
                              interval: '310',
                              texttableentry: 'ExpansionValveOneSuperHeatControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_311',
                              interval: '311',
                              texttableentry: 'ExpansionValveOneSuperHeatControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_312',
                              interval: '312',
                              texttableentry: 'ExpansionValveOneSubcoolingControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_313',
                              interval: '313',
                              texttableentry: 'ExpansionValveOneSubcoolingControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_314',
                              interval: '314',
                              texttableentry:
                                'ExpansionValveOneDischargeTemperatureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_315',
                              interval: '315',
                              texttableentry:
                                'ExpansionValveOneDischargeTemperatureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_316',
                              interval: '316',
                              texttableentry: 'ExpansionValveOneFullyOpenedActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_317',
                              interval: '317',
                              texttableentry: 'ExpansionValveOneFullyOpenedDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_318',
                              interval: '318',
                              texttableentry: 'ExpansionValveOneHoldOnActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_319',
                              interval: '319',
                              texttableentry: 'ExpansionValveOneHoldOnDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_320',
                              interval: '320',
                              texttableentry: 'ExpansionValveOneManualModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_321',
                              interval: '321',
                              texttableentry: 'ExpansionValveOneManualModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_322',
                              interval: '322',
                              texttableentry:
                                'ExpansionValveOneMaxEvaporatingPressureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_323',
                              interval: '323',
                              texttableentry:
                                'ExpansionValveOneMaxEvaporatingPressureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_324',
                              interval: '324',
                              texttableentry:
                                'ExpansionValveOneMinEvaporatingPressureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_325',
                              interval: '325',
                              texttableentry:
                                'ExpansionValveOneMinEvaporatingPressureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_326',
                              interval: '326',
                              texttableentry:
                                'ExpansionValveOneMaxSuctionSuperheatControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_327',
                              interval: '327',
                              texttableentry:
                                'ExpansionValveOneMaxSuctionSuperheatControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_328',
                              interval: '328',
                              texttableentry: 'ExpansionValveOneMaxSubcoolingControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_329',
                              interval: '329',
                              texttableentry: 'ExpansionValveOneMaxSubcoolingControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_330',
                              interval: '330',
                              texttableentry: 'ExpansionValveOneDischargeSuperheatControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_331',
                              interval: '331',
                              texttableentry:
                                'ExpansionValveOneDischargeSuperheatControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_332',
                              interval: '332',
                              texttableentry: 'ExpansionValveTwoIdle',
                            },
                            {
                              TI_texttableentry: 'TI_S_333',
                              interval: '333',
                              texttableentry: 'ExpansionValveTwoCalibrationActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_334',
                              interval: '334',
                              texttableentry: 'ExpansionValveTwoCalibrationDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_335',
                              interval: '335',
                              texttableentry: 'ExpansionValveTwoPressureEqualizationActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_336',
                              interval: '336',
                              texttableentry: 'ExpansionValveTwoPressureEqualizationDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_337',
                              interval: '337',
                              texttableentry: 'ExpansionValveTwoStartupActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_338',
                              interval: '338',
                              texttableentry: 'ExpansionValveTwoStartupDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_339',
                              interval: '339',
                              texttableentry: 'ExpansionValveTwoOpenLoopControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_340',
                              interval: '340',
                              texttableentry: 'ExpansionValveTwoOpenLoopControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_341',
                              interval: '341',
                              texttableentry: 'ExpansionValveTwoSuperHeatControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_342',
                              interval: '342',
                              texttableentry: 'ExpansionValveTwoSuperHeatControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_343',
                              interval: '343',
                              texttableentry: 'ExpansionValveTwoSubcoolingControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_344',
                              interval: '344',
                              texttableentry: 'ExpansionValveTwoSubcoolingControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_345',
                              interval: '345',
                              texttableentry:
                                'ExpansionValveTwoDischargeTemperatureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_346',
                              interval: '346',
                              texttableentry:
                                'ExpansionValveTwoDischargeTemperatureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_347',
                              interval: '347',
                              texttableentry: 'ExpansionValveTwoFullyOpenedActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_348',
                              interval: '348',
                              texttableentry: 'ExpansionValveTwoFullyOpenedDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_349',
                              interval: '349',
                              texttableentry: 'ExpansionValveTwoHoldOnActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_350',
                              interval: '350',
                              texttableentry: 'ExpansionValveTwoHoldOnDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_351',
                              interval: '351',
                              texttableentry: 'ExpansionValveTwoManualModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_352',
                              interval: '352',
                              texttableentry: 'ExpansionValveTwoManualModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_353',
                              interval: '353',
                              texttableentry:
                                'ExpansionValveTwoMaxEvaporatingPressureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_354',
                              interval: '354',
                              texttableentry:
                                'ExpansionValveTwoMaxEvaporatingPressureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_355',
                              interval: '355',
                              texttableentry:
                                'ExpansionValveTwoMinEvaporatingPressureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_356',
                              interval: '356',
                              texttableentry:
                                'ExpansionValveTwoMinEvaporatingPressureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_357',
                              interval: '357',
                              texttableentry:
                                'ExpansionValveTwoMaxSuctionSuperheatControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_358',
                              interval: '358',
                              texttableentry:
                                'ExpansionValveTwoMaxSuctionSuperheatControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_359',
                              interval: '359',
                              texttableentry: 'ExpansionValveTwoMaxSubcoolingControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_360',
                              interval: '360',
                              texttableentry: 'ExpansionValveTwoMaxSubcoolingControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_361',
                              interval: '361',
                              texttableentry: 'ExpansionValveTwoDischargeSuperheatControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_362',
                              interval: '362',
                              texttableentry:
                                'ExpansionValveTwoDischargeSuperheatControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_363',
                              interval: '363',
                              texttableentry: 'HeatPumpPrimaryPumpOneOff',
                            },
                            {
                              TI_texttableentry: 'TI_S_364',
                              interval: '364',
                              texttableentry: 'HeatPumpPrimaryPumpOneManualModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_365',
                              interval: '365',
                              texttableentry: 'HeatPumpPrimaryPumpOneManualModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_366',
                              interval: '366',
                              texttableentry: 'HeatPumpPrimaryPumpOneControlModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_367',
                              interval: '367',
                              texttableentry: 'HeatPumpPrimaryPumpOneControlModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_368',
                              interval: '368',
                              texttableentry:
                                'HeatPumpPrimaryPumpOneMaxEvaporatingPressureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_369',
                              interval: '369',
                              texttableentry:
                                'HeatPumpPrimaryPumpOneMaxEvaporatingPressureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_370',
                              interval: '370',
                              texttableentry: 'HeatPumpPrimaryPumpOneDefrostAvoidingModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_371',
                              interval: '371',
                              texttableentry:
                                'HeatPumpPrimaryPumpOneDefrostAvoidingModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_372',
                              interval: '372',
                              texttableentry: 'HeatPumpPrimaryPumpTwoOff',
                            },
                            {
                              TI_texttableentry: 'TI_S_373',
                              interval: '373',
                              texttableentry: 'HeatPumpPrimaryPumpTwoManualModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_374',
                              interval: '374',
                              texttableentry: 'HeatPumpPrimaryPumpTwoManualModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_375',
                              interval: '375',
                              texttableentry: 'HeatPumpPrimaryPumpTwoControlModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_376',
                              interval: '376',
                              texttableentry: 'HeatPumpPrimaryPumpTwoControlModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_377',
                              interval: '377',
                              texttableentry:
                                'HeatPumpPrimaryPumpTwoMaxEvaporatingPressureControlActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_378',
                              interval: '378',
                              texttableentry:
                                'HeatPumpPrimaryPumpTwoMaxEvaporatingPressureControlDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_379',
                              interval: '379',
                              texttableentry: 'HeatPumpPrimaryPumpTwoDefrostAvoidingModeActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_380',
                              interval: '380',
                              texttableentry:
                                'HeatPumpPrimaryPumpTwoDefrostAvoidingModeDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_381',
                              interval: '381',
                              texttableentry: 'BaseHeaterActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_382',
                              interval: '382',
                              texttableentry: 'BaseHeaterDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_383',
                              interval: '383',
                              texttableentry: 'CrankCaseHeaterActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_384',
                              interval: '384',
                              texttableentry: 'CrankCaseHeaterDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_385',
                              interval: '385',
                              texttableentry: 'FanDuctHeaterActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_386',
                              interval: '386',
                              texttableentry: 'FanDuctHeaterDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_387',
                              interval: '387',
                              texttableentry: 'RefrigerantCycleOperationModeValveSwitchToHeating',
                            },
                            {
                              TI_texttableentry: 'TI_S_388',
                              interval: '388',
                              texttableentry: 'RefrigerantCycleOperationModeValveSwitchToCooling',
                            },
                            {
                              TI_texttableentry: 'TI_S_389',
                              interval: '389',
                              texttableentry: 'ExternalHeaterDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_390',
                              interval: '390',
                              texttableentry: 'BivalenzMixerForExternalSupportActivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_391',
                              interval: '391',
                              texttableentry: 'BivalenzMixerForExternalSupportDeactivated',
                            },
                            {
                              TI_texttableentry: 'TI_S_392',
                              interval: '392',
                              texttableentry: 'RefrigerantCycleAppStateTransitionHeatingToDefrost',
                            },
                            {
                              TI_texttableentry: 'TI_S_65534',
                              interval: '65534',
                              texttableentry: 'Unused',
                            },
                          ],
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DTC',
                          unit: '',
                          translationid: 'TI_DtcStatus',
                          bitposition: '0',
                          name: 'PA_DTC',
                          value: 'NoStatus',
                        },
                        {
                          semantic: 'DATETIME',
                          longname: 'DtcTime',
                          byteposition: '2',
                          dopname: '8 Byte Structure DateTime',
                          precision: '',
                          byteLength: '-1',
                          type: 'eSTRUCTURE',
                          shortname: 'PA_DtcTime',
                          constraints: '',
                          structure: [
                            {
                              semantic: 'DATE',
                              longname: 'Date',
                              byteposition: '0',
                              dopname: '4 Byte Structure Date',
                              precision: '',
                              byteLength: '-1',
                              type: 'eSTRUCTURE',
                              shortname: 'PA_Date',
                              constraints: '',
                              structure: [
                                {
                                  semantic: 'CENTURY',
                                  longname: 'Century',
                                  byteposition: '0',
                                  dopname: '1 Byte Identical uint8 Century',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Centu',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Centu',
                                  unit: '',
                                  translationid: 'TI_Century',
                                  bitposition: '0',
                                  name: 'PA_Centu',
                                  value: '0',
                                },
                                {
                                  semantic: 'YEAR',
                                  longname: 'Year',
                                  byteposition: '1',
                                  dopname: '1 Byte Identical uint8 Year',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Year',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Year',
                                  unit: 'yr',
                                  translationid: 'TI_Year',
                                  bitposition: '0',
                                  name: 'PA_Year',
                                  value: '0',
                                },
                                {
                                  semantic: 'MONTH',
                                  longname: 'Month',
                                  byteposition: '2',
                                  dopname: '1 Byte Identical uint8 Month',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Month',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Month',
                                  unit: 'm',
                                  translationid: 'TI_Month',
                                  bitposition: '0',
                                  name: 'PA_Month',
                                  value: '0',
                                },
                                {
                                  semantic: 'DAY',
                                  longname: 'Day',
                                  byteposition: '3',
                                  dopname: '1 Byte Identical uint8 Day',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Day',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date/PA_Day',
                                  unit: 'd',
                                  translationid: 'TI_Day',
                                  bitposition: '0',
                                  name: 'PA_Day',
                                  value: '0',
                                },
                              ],
                              path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Date',
                              unit: '',
                              translationid: 'TI_Date',
                              bitposition: '0',
                              name: 'PA_Date',
                              value: '4',
                            },
                            {
                              semantic: 'TIME',
                              longname: 'Time',
                              byteposition: '4',
                              dopname: '4 Byte Structure Time',
                              precision: '',
                              byteLength: '-1',
                              type: 'eSTRUCTURE',
                              shortname: 'PA_Time',
                              constraints: '',
                              structure: [
                                {
                                  semantic: 'WEEKDAY',
                                  longname: 'Weekday',
                                  byteposition: '0',
                                  dopname: '1 Byte TextTable WeekDay',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eTEXTTABLE',
                                  shortname: 'PA_Weekd',
                                  constraints: '',
                                  structure: [
                                    {
                                      TI_texttableentry: 'TI_Monday',
                                      interval: '0',
                                      texttableentry: 'Monday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Tuesday',
                                      interval: '1',
                                      texttableentry: 'Tuesday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Wednesday',
                                      interval: '2',
                                      texttableentry: 'Wednesday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Thursday',
                                      interval: '3',
                                      texttableentry: 'Thursday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Friday',
                                      interval: '4',
                                      texttableentry: 'Friday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Saturday',
                                      interval: '5',
                                      texttableentry: 'Saturday',
                                    },
                                    {
                                      TI_texttableentry: 'TI_Sunday',
                                      interval: '6',
                                      texttableentry: 'Sunday',
                                    },
                                  ],
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Weekd',
                                  unit: '',
                                  translationid: 'TI_Weekday',
                                  bitposition: '0',
                                  name: 'PA_Weekd',
                                  value: 'Monday',
                                },
                                {
                                  semantic: 'HOUR',
                                  longname: 'Hour',
                                  byteposition: '1',
                                  dopname: '1 Byte Identical uint8 Hour',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Hour',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Hour',
                                  unit: 'h',
                                  translationid: 'TI_Hour',
                                  bitposition: '0',
                                  name: 'PA_Hour',
                                  value: '0',
                                },
                                {
                                  semantic: 'MINUTE',
                                  longname: 'Minute',
                                  byteposition: '2',
                                  dopname: '1 Byte Identical uint8 Minute',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Minut',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Minut',
                                  unit: 'min',
                                  translationid: 'TI_Minute',
                                  bitposition: '0',
                                  name: 'PA_Minut',
                                  value: '0',
                                },
                                {
                                  semantic: 'SECOND',
                                  longname: 'Second',
                                  byteposition: '3',
                                  dopname: '1 Byte Identical uint8 Second',
                                  precision: '',
                                  byteLength: '8',
                                  type: 'eA_UINT32',
                                  shortname: 'PA_Secon',
                                  constraints: '[0:255]',
                                  path:
                                    'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time/PA_Secon',
                                  unit: 's',
                                  translationid: 'TI_Second',
                                  bitposition: '0',
                                  name: 'PA_Secon',
                                  value: '0',
                                },
                              ],
                              path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime/PA_Time',
                              unit: '',
                              translationid: 'TI_Time',
                              bitposition: '0',
                              name: 'PA_Time',
                              value: '4',
                            },
                          ],
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_DtcTime',
                          unit: '',
                          translationid: 'TI_Time',
                          bitposition: '0',
                          name: 'PA_DtcTime',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          longname: 'BusAddress',
                          byteposition: '10',
                          dopname: '1 Byte Identical uint8 Hex',
                          precision: '',
                          byteLength: '8',
                          type: 'eA_UINT32',
                          shortname: 'PA_BusAddre',
                          constraints: '[0:255]',
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusAddre',
                          unit: '',
                          translationid: 'TI_BusAddress',
                          bitposition: '0',
                          name: 'PA_BusAddre',
                          value: '0',
                        },
                        {
                          semantic: 'ENUM',
                          longname: 'BusType',
                          byteposition: '11',
                          dopname: '1 Byte TextTable BusType',
                          precision: '',
                          byteLength: '8',
                          type: 'eTEXTTABLE',
                          shortname: 'PA_BusType',
                          constraints: '',
                          structure: [
                            {
                              TI_texttableentry: 'TI_OwnBus',
                              interval: '0',
                              texttableentry: 'OwnBus',
                            },
                            {
                              TI_texttableentry: 'TI_PlusBus',
                              interval: '1',
                              texttableentry: 'PlusBus',
                            },
                            {
                              TI_texttableentry: 'TI_CanInternal',
                              interval: '2',
                              texttableentry: 'CanInternal',
                            },
                            {
                              TI_texttableentry: 'TI_CanExternal',
                              interval: '3',
                              texttableentry: 'CanExternal',
                            },
                            {
                              TI_texttableentry: 'TI_InternalUart',
                              interval: '4',
                              texttableentry: 'InternalUart',
                            },
                            {
                              TI_texttableentry: 'TI_Zigbee',
                              interval: '5',
                              texttableentry: 'Zigbee',
                            },
                            {
                              TI_texttableentry: 'TI_CanRaw',
                              interval: '6',
                              texttableentry: 'CanRaw',
                            },
                            {
                              TI_texttableentry: 'TI_Unkown',
                              interval: '7',
                              texttableentry: 'Unkown',
                            },
                            {
                              TI_texttableentry: 'TI_ModBus',
                              interval: '8',
                              texttableentry: 'ModBus',
                            },
                            {
                              TI_texttableentry: 'TI_EEBUS',
                              interval: '9',
                              texttableentry: 'EEBUS',
                            },
                            {
                              TI_texttableentry: 'TI_PlusBusTwo',
                              interval: '10',
                              texttableentry: 'PlusBusTwo',
                            },
                            {
                              TI_texttableentry: 'TI_ISquaredCBus',
                              interval: '11',
                              texttableentry: 'ISquaredCBus',
                            },
                            {
                              TI_texttableentry: 'TI_HemsBus',
                              interval: '12',
                              texttableentry: 'HemsBus',
                            },
                            {
                              TI_texttableentry: 'TI_SolarLogBus',
                              interval: '13',
                              texttableentry: 'SolarLogBus',
                            },
                            {
                              TI_texttableentry: 'TI_ServiceBus',
                              interval: '14',
                              texttableentry: 'ServiceBus',
                            },
                          ],
                          path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu/PA_BusType',
                          unit: '',
                          translationid: 'TI_BusType',
                          bitposition: '0',
                          name: 'PA_BusType',
                          value: 'OwnBus',
                        },
                      ],
                      path: 'PA_Struc/PA_DTC/STR_12ByteStrucDTCStatu',
                      unit: '',
                      translationid: '',
                      bitposition: '0',
                      name: 'STR_12ByteStrucDTCStatu',
                      value: '4',
                    },
                  ],
                  path: 'PA_Struc/PA_DTC',
                  unit: '',
                  translationid: 'TI_DTC',
                  bitposition: '0',
                  name: 'PA_DTC',
                  value: '1',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
